export const LANG_CHOOSER_TYPES = {
    dropdown: 'dropdown',
    slider: 'slider',
} as const;
